import MicroLearning from 'assets/icons/microlearning.svg';
import MLearning from 'assets/icons/m-learning.svg';
import BlendedLearning from 'assets/icons/blended-learning.svg';
import BlendedLearningJourney from 'assets/icons/blended-learning-journey.svg';
import EmptyLearning from 'assets/icons/empty-learning.svg';

import templates from './templates';

import {Theme, Template} from './types';

export const themes: Theme[] = [
  {
    title: 'Kies een blauwdruk',
    templates: templates.map((template: Template) => {
      let icon = '';

      switch (template.id) {
        case 'micro-learning':
          icon = MicroLearning;
          break;
        case 'm-learning':
          icon = MLearning;
          break;
        case 'blended-learning-journey':
          icon = BlendedLearningJourney;
          break;
        case 'blended-guidance':
          icon = BlendedLearning;
          break;
      }
      return {
        icon,
        ...template,
      };
    }),
  },
  {
    title: 'Of ontwikkel een Wisbit zonder blauwdruk',
    templates: [
      {
        icon: EmptyLearning,
        id: '',
        name: 'Lege Wisbit',
        time: 'Duur zelf te bepalen',
        descriptions: [
          'Duur zelf te bepalen',
          'Korte of lange Wisbit (mobile learning)',
          'Met of zonder live meetings (groep of individueel)',
        ],
      },
    ],
  },
];
